import * as React from 'react';
import {
    Create,
    TextInput,
    SimpleForm,
    required,
    NumberInput,
    minValue,
    useDataProvider,
    AutocompleteInput,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';
import HTMLEditorInput from '../../common/inputs/HTMLEditorInput';
import { useSearchParams } from 'react-router-dom';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

export const TopicsRender = (choice: any) => `${choice.name}`;

const PodcastCreate = () => {
    const [searchParams] = useSearchParams();
    const topicId = searchParams.get('topicId');
    const dataProvider = useDataProvider();

    const isDisabled = !!topicId;
    const [topics, setTopics] = React.useState([]) as any;

    React.useEffect(() => {
        dataProvider
            .getList('podcast-topics', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => setTopics(data))
            .catch(error => console.error(error));
    }, [dataProvider]);

    return (
        <Create redirect={'/podcasts'} resource="podcasts">
            <SimpleForm>
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    source="Thumbnail"
                    required={true}
                    accept={'image/*'}
                />
                <TextInput source="Title" fullWidth validate={[required(), validateNotEmpty]} />
                <FileUpload
                    source="Url"
                    type="PODCAST"
                    label="select pdf url"
                    required={true}
                    accept={'audio/*'}
                />
                <NumberInput source="DisplayOrder" fullWidth validate={[minValue(1)]} />
                <AutocompleteInput
                    source="TopicId"
                    choices={topics}
                    optionText={TopicsRender}
                    fullWidth
                    isRequired
                    disabled={isDisabled}
                />
                <HTMLEditorInput source="Description" validate={[required()]} fullWidth />
            </SimpleForm>
        </Create>
    );
};

export default PodcastCreate;
